// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle'

// import Swiper and modules styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const numberOfSlides = document.querySelectorAll('.swiper-7 .swiper-slide').length
const countSlides = numberOfSlides <= 4 ? numberOfSlides : 4

// init Swiper:
const swiper = new Swiper('.swiper-7', {
	autoplay: {
		delay: 5000
	},
	loop: true,
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next-custom-7',
		prevEl: '.swiper-button-prev-custom-7'
	},

	breakpoints: {
		640: {
			slidesPerView: 2,
			spaceBetween: 20
		},

		1280: {
			slidesPerView: countSlides,
			spaceBetween: 20
		}
	}
})
